export default {
  type: 'user_invites_by_employee_ids',
  config: null
};
//# sourceMappingURL=user_invites_by_employee_ids.js.map